import { Gift, ArrowRight } from 'lucide-react';
import { CONTACT_INFO } from '../data/content';
export const OfferCard = () => {

    const handleTicketClick = (e) => {
      const ticketId = Math.floor(1000 + Math.random() * 9000);
      const subject = encodeURIComponent(`Support Inquiry - Ticket #${ticketId}`);
      
      // Update the link href dynamically upon click
      e.currentTarget.href = `mailto:${CONTACT_INFO.email}?subject=${subject}`;
    }

  return(
  <section id="offer" className="px-6 py-20">
    <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl p-1 shadow-2xl">
      <div className="bg-[#0A192F] rounded-[22px] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
        <div className="p-5 bg-blue-500/10 rounded-2xl">
          <Gift size={40} className="text-blue-400" />
        </div>
        <div className="flex-1">
          <h2 className="text-3xl font-bold text-white mb-2">Get 5 FREE Support Tickets</h2>
          <p className="text-slate-400">Available to all new customers. Test our speed and expertise with no initial cost.</p>
        </div>
        <a 
        href={`mailto:${CONTACT_INFO.email}`}
        onClick={handleTicketClick}
        className="bg-white text-blue-900 px-8 py-4 rounded-xl font-black flex items-center gap-2 hover:scale-105 transition active:scale-95">
          CLAIM NOW <ArrowRight size={18} />
        </a>
      </div>
    </div>
  </section>
  );
};